import { interpolateColor, useAnimatedStyle } from 'react-native-reanimated'
import cn from '@ui/utils/cn'
import { colors } from '@ui/colors'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import { AnimatedPressable } from '@ui/animated/nativewindReanimated'

import { SegmentedItemProps } from './types'
import SegmentedOption from './SegmentedOption'

export default function SegmentedItem<T extends string>({
  option,
  classNameOption,
  isDisabled,
  onChange,
  onLayout,
  index,
  animation,
  selection,
}: SegmentedItemProps<T>) {
  const {
    animation: animated_press,
    onPressIn,
    onPressOut,
  } = useAnimatedPress()

  const styleItem = useAnimatedStyle(() => ({
    backgroundColor: interpolateColor(
      animated_press.value,
      [0, 1],
      [colors.text0, colors.text10]
    ),
  }))

  return (
    <AnimatedPressable
      key={option.id}
      className={cn(
        'flex h-8 items-center justify-center rounded-full',
        classNameOption
      )}
      onPressIn={onPressIn}
      onPressOut={onPressOut}
      onPress={() => onChange?.(option)}
      disabled={isDisabled}
      style={[styleItem]}
      onLayout={(event) => onLayout(event, option)}
    >
      <SegmentedOption
        animation={animation}
        selection={selection}
        index={index}
        text={option.label}
        isDisabled={isDisabled}
      />
    </AnimatedPressable>
  )
}
